/* Metadata only. Variant selection remains owned by the existing product section. */
(function () {
  'use strict';
  if (window.DiyonaProductMetadataInstalled) return;
  window.DiyonaProductMetadataInstalled = true;
  var controllers = Object.create(null);
  var variantKeys = ['sku', 'image', 'material', 'additionalProperty', 'offers'];
  function safeJson(value) {
    return JSON.stringify(value).replace(/</g, '\\u003c').replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
  }
  function apply(selection) {
    try {
      if (!selection || !/^\d+$/.test(String(selection.productId)) || !/^\d+$/.test(String(selection.variantId))) return;
      var controller = controllers[String(selection.productId)];
      if (!controller || !Object.prototype.hasOwnProperty.call(controller.variants, String(selection.variantId))) return;
      var fields = controller.variants[String(selection.variantId)];
      var next = Object.assign({}, controller.base);
      variantKeys.forEach(function (key) {
        delete next[key];
        if (Object.prototype.hasOwnProperty.call(fields, key)) next[key] = fields[key];
      });
      controller.node.textContent = safeJson(next);
      controller.node.setAttribute('data-diyona-variant-id', String(selection.variantId));
    } catch (_) { /* Malformed or unavailable metadata never interrupts purchasing. */ }
  }
  function replay() {
    try {
      var selections = window.DiyonaMetadataSelections || {};
      Object.keys(controllers).forEach(function (id) { apply(selections[id]); });
    } catch (_) { /* Keep page behavior independent of metadata. */ }
  }
  function initialize() {
    document.querySelectorAll('script[data-diyona-metadata-map]').forEach(function (mapNode) {
      try {
        var payload = JSON.parse(mapNode.textContent);
        var id = String(payload.productId);
        if (!/^\d+$/.test(id) || !payload.variants) return;
        var node = document.getElementById('diyona-product-metadata-' + id);
        if (!node) return;
        controllers[id] = { node: node, base: JSON.parse(node.textContent), variants: payload.variants };
      } catch (_) { /* A bad metadata block is isolated to its own product. */ }
    });
    replay();
  }
  window.addEventListener('diyona:metadata-variant', function (event) { apply(event.detail); });
  window.addEventListener('pageshow', replay);
  initialize();
}());
